import { render, staticRenderFns } from "./ClientsInfo.vue?vue&type=template&id=29485ed0&"
import script from "./ClientsInfo.vue?vue&type=script&lang=js&"
export * from "./ClientsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports